export function startingAnimation() {
    setTimeout(function() {
        document.getElementById('opening-banner').style.marginLeft = "0px"
    }, 800)
    document.getElementById('home').style.opacity = "1"
}

export function menuAnimation() {
    setTimeout(function() {
        const menuItems = document.getElementsByClassName('menu-item')
        let timer = 100
        for(let i = 0; i <menuItems.length; i++) {
            setTimeout(() => {
                menuItems[i].style.opacity = "1"
            }, timer);
            timer = timer + 100
        }
    }, 500) 
}

export function aboutScreenAnimations() {
    document.getElementById('about-us').style.borderBottom = "1px solid rgb(255, 174, 0)"
    document.getElementById('about-us').style.color = "rgb(255, 174, 0)"
    document.getElementById('policy-menu-item').style.borderBottom = "none"
    document.getElementById('full-screen-menu').style.backgroundColor = "rgba(79, 82, 64, 0.6)"
    document.getElementById('full-screen-menu').style.height = "60px"
    document.getElementById('logo-wrapper-full').style.height = '90px'
    document.getElementById('logo-wrapper-full').style.width = '100px'
    const menuItems = document.getElementsByClassName("menu-item")
        menuItems[0].style.color = '#fff'
        menuItems[0].style.marginTop = '16px'
        menuItems[0].style.fontSize = '18px'
        menuItems[1].style.marginTop = '16px'
        menuItems[1].style.fontSize = '18px'
        menuItems[2].style.color = '#fff'
        menuItems[2].style.marginTop = '16px'
        menuItems[2].style.fontSize = '18px'
        menuItems[3].style.color = '#fff'
        menuItems[3].style.marginTop = '16px'
        menuItems[3].style.fontSize = '18px'
        menuItems[4].style.color = '#fff'
        menuItems[4].style.marginTop = '16px'
        menuItems[4].style.fontSize = '18px'
}

export function backtoHomeAnimations() {
    document.getElementById('about-us').style.borderBottom = "none"
    document.getElementById('policy-menu-item').style.borderBottom = "none"
    document.getElementById('full-screen-menu').style.backgroundColor = "rgba(255, 255, 255, 0.8)"
    document.getElementById('full-screen-menu').style.height = "100px"
    document.getElementById('logo-wrapper-full').style.height = '180px'
    document.getElementById('logo-wrapper-full').style.width = '200px'
    const menuItems = document.getElementsByClassName("menu-item")
        menuItems[0].style.color = '#000'
        menuItems[0].style.marginTop = '38px'
        menuItems[0].style.fontSize = '18px'
        menuItems[1].style.color = '#000'
        menuItems[1].style.marginTop = '38px'
        menuItems[1].style.fontSize = '18px'
        menuItems[2].style.color = '#000'
        menuItems[2].style.marginTop = '38px'
        menuItems[2].style.fontSize = '18px'
        menuItems[3].style.color = '#000'
        menuItems[3].style.marginTop = '38px'
        menuItems[3].style.fontSize = '18px'
        menuItems[4].style.color = 'rgb(255, 174, 0)'
        menuItems[4].style.marginTop = '38px'
        menuItems[4].style.fontSize = '18px'
}

export function policySectionAnimations() {
    document.getElementById('about-us').style.borderBottom = "none"
    document.getElementById('about-us').style.color = "#fff"
    document.getElementById('policy-menu-item').style.borderBottom = "1px solid rgb(255, 174, 0)"
    document.getElementById('policy-menu-item').style.color = "rgb(255, 174, 0)"
}

export function teacherListAnimations() {
    document.getElementById('teachers-page').scrollIntoView({behavior: "smooth"})
    document.getElementById('full-screen-menu').style.backgroundColor = "rgba(67, 82, 64, 0.6)"
    document.getElementById('teacher-menu-item').style.borderBottom = "1px solid rgb(255, 174, 0)"
    document.getElementById('teacher-menu-item').style.color = "rgb(255, 174, 0)"
    document.getElementById('full-screen-menu').style.backgroundColor = "rgba(106,109,90,0.9)"
    document.getElementById('full-screen-menu').style.height = "60px"
    document.getElementById('logo-wrapper-full').style.height = '90px'
    document.getElementById('logo-wrapper-full').style.width = '100px'
    const menuItems = document.getElementsByClassName("menu-item")
    menuItems[0].style.color = '#fff'
    menuItems[0].style.marginTop = '16px'
    menuItems[0].style.fontSize = '18px'
    menuItems[1].style.marginTop = '16px'
    menuItems[1].style.color = '#fff'
    menuItems[1].style.fontSize = '18px'
    menuItems[2].style.color = '#fff'
    menuItems[2].style.marginTop = '16px'
    menuItems[2].style.fontSize = '18px'
    menuItems[3].style.color = '#fff'
    menuItems[3].style.marginTop = '16px'
    menuItems[3].style.fontSize = '18px'
    menuItems[4].style.color = '#fff'
    menuItems[4].style.marginTop = '16px'
    menuItems[4].style.fontSize = '18px'

    setTimeout(function(){
        document.getElementById('the-list').style.opacity = "1"
    }, 2400)
    setTimeout(function(){
        document.getElementById('teacher-searchbar').style.opacity = '1'
    }, 2600)
}

export function calendarWarningAnimation() {
    document.getElementById('calendar-warning-wrapper').style.transitionDuration = "300ms"
    document.getElementById('calendar-warning-wrapper').style.backgroundColor = "rgba(0, 0, 0, 0.8)"
    document.getElementById('calendar-warning-box').style.transitionDuration = "400ms"
    document.getElementById('calendar-warning-box').style.marginTop = "200px"
}
export function calendarWarningCloseAnimation() {
    document.getElementById('calendar-warning-wrapper').style.transitionDuration = "300ms"
    document.getElementById('calendar-warning-wrapper').style.backgroundColor = "rgba(0, 0, 0, 0)"
    document.getElementById('calendar-warning-box').style.transitionDuration = "400ms"
    document.getElementById('calendar-warning-box').style.marginTop = "-500px"
}
export function teacherPortalStart() {
    document.getElementById('timesheet-box').style.transitionDuration = "500ms"
    document.getElementById('timesheet-box').style.marginTop = "10px"
    document.getElementById('timesheet-box').style.opacity = "1"
    document.getElementById('timesheet-box').style.transitionTimingFunction = "cubic-bezier(0.25, 1, 0.5, 1)"
    document.getElementById('dashboard-menu').style.transitionDelay = "200ms"
    document.getElementById('dashboard-menu').style.transitionDuration = "500ms"
    document.getElementById('dashboard-menu').style.marginLeft = "0px"
    document.getElementById('dashboard-menu').style.opacity = "1"
    document.getElementById('availability-wrapper').style.opacity = "1"
}

export const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://app.atharo.app'